import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogAction } from '../../../../shared/contracts/dialog.interface';

@Component({
  selector: 'kc-company-dialog',
  standalone: true,
  imports: [Button, FormsModule, InputText, ReactiveFormsModule, FloatLabel],
  templateUrl: './company-dialog.component.html',
})
export class CompanyDialogComponent implements OnDestroy, OnInit {
  static readonly DIALOG_CONFIG: DynamicDialogConfig = {
    header: 'Dati Azienda',
    width: '95vw',
    style: { 'max-width': '500px' },
    modal: true,
    focusOnShow: false,
  };

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      code: [''],
      vatNumber: [''],
    });

    if (this.config.data) {
      this.form.patchValue(this.config.data);
    }
  }

  save() {
    if (this.form.invalid) return;
    this.ref.close({ action: DialogAction.OK, data: this.form.value });
  }

  closeDialog() {
    this.ref.close({ action: DialogAction.CLOSE });
  }

  ngOnDestroy() {
    if (this.ref) this.ref.close();
  }
}
